const Header = ({
  icon: Icon,
  iconBg,
  iconColor,
  title,
  description
}) => {
  return (
    <div className="flex items-center gap-3">
      <div className={`rounded-xl w-10 h-10 flex items-center justify-center ${iconBg}`}>
        <Icon size={20} className={iconColor} />
      </div>

      <div className="flex-1 min-w-0">
        <p className="font-bold text-lg text-base-content">{title}</p>
        <p className="text-gray-500 mt-1 text-xs">{description}</p>
      </div>
    </div>
  )
}

export default Header;
